import axios from "axios";
import { getUserFromLS } from "../utils/getUserFromLS";
import type { INSIGHT_CATEGORY, ISocialPromptSeriesReadWithStatus } from "../Types/account";
import { getTutorialSocialPromptsForInsight } from "./tutorialFixtureResponses";

/** Lists social prompt **series** for an insight anchor (series-first API). */
export const getSocialPromptsForInsight = (
    insightId: string,
    category: INSIGHT_CATEGORY | "CONTACT_INTELLIGENCE" | "INSIGHTS_ITEM",
    callback: (response: ISocialPromptSeriesReadWithStatus[]) => void,
    errorCallback: (error: unknown) => void,
    accountId?: string | null
) => {
    const fixture = category === "INSIGHTS_ITEM" ? null : getTutorialSocialPromptsForInsight(insightId, category);
    if (fixture) {
      if (callback != null) {
        callback(fixture);
      }
      return Promise.resolve(fixture);
    }

    const user = getUserFromLS();

    let URL = category === "INSIGHTS_ITEM"
        ? `${import.meta.env.VITE_API_BASE_URL}/social_prompts/series/items/${encodeURIComponent(insightId)}`
        : `${import.meta.env.VITE_API_BASE_URL}/social_prompts/series/insights/${category}/${insightId}`;
    if (accountId != null && accountId !== "") {
        URL += `?account_id=${encodeURIComponent(accountId)}`;
    }
    return axios(URL, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${user.access_token}`,
        },
    })
        .then((response) => {
            if (callback != null) {
                callback(response.data as ISocialPromptSeriesReadWithStatus[]);
            }
        })
        .catch((error) => {
            if (errorCallback != null) {
                errorCallback(error);
            }
        });
};
